import { isNull } from 'lodash/fp';

import { ImageType } from '../../../types/image';
import imageUrlBuilder from '../image-url-builder';
import type { ImageObject, Maybe } from '../../../types/__codegen__/sanity/graphql';

type GetImageAttributesProps = {
  imageObject?: Maybe<ImageObject>;
  height?: number;
  width?: number;
};

const getImageAttributes = ({ imageObject, height, width }: GetImageAttributesProps): ImageType | null => {
  const image = imageObject?.image;

  if (!image?.asset) {
    return null;
  }

  const caption = imageObject?.caption ?? '';
  return {
    alt: isNull(caption) ? '' : caption,
    // @ts-expect-error - Automatic, Please fix when editing this file
    src: imageUrlBuilder(image).height(height).width(width).url(),
  };
};

export default getImageAttributes;
